
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"42","height":"42","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M17.174 7.066l-5.042-4.622-.377.346-4.666 4.276a.46.46 0 000 .692.568.568 0 00.755 0l3.754-3.442v14.468c0 .27.24.489.534.489.295 0 .533-.219.533-.49V4.317l3.755 3.442c.104.095.24.143.377.143a.558.558 0 00.377-.143.46.46 0 000-.692","id":"download-path-1"}})]),_c('g',{attrs:{"id":"download-M028_EditorialHero","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"download-M029_ItineraryIntro_D","transform":"translate(-150 -71)"}},[_c('g',{attrs:{"id":"download-Group-19","transform":"translate(151 72)"}},[_c('g',{attrs:{"id":"download-Group-20"}},[_c('g',{attrs:{"id":"download-Icon-/-Arrow","transform":"matrix(1 0 0 -1 8 28.207)"}},[_c('mask',{attrs:{"id":"download-mask-2","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#download-path-1"}})]),_c('use',{attrs:{"id":"download-Fill-1","fill":"#1D1D1B","fill-rule":"evenodd","xlink:href":"#download-path-1"}}),_c('g',{attrs:{"id":"download-Colour-/-Black","mask":"url(#download-mask-2)","fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"id":"download-Rectangle","d":"M0 0h24v22H0z"}})])]),_c('path',{attrs:{"id":"download-Line-4","stroke":"#000","stroke-linecap":"square","d":"M11.172 28.603h17.449"}}),_c('circle',{attrs:{"id":"download-Oval","stroke":"#C9C9C9","cx":"20","cy":"20","r":"20"}})])])])])])
          )
        }
      }
    